import { Link } from 'react-router-dom'
import { IconButton, Typography } from '@material-tailwind/react'
import { AiOutlinePlus } from 'react-icons/ai'
import { useTranslation } from 'react-i18next'
import AgamiCardGrid from '../ViewDashboard/AgamiCardGrid'
import { useFeatureAuth, useFeatureFlag } from '../hooks/authorization'
import { usePageTitle } from '../hooks/toolkit'
import { FEATURE_FLAGS, FEATURES } from '../utils/constants/features.constants'
import { useAgamiRoutes } from '../hooks/useAgamiRoutes'
import { AgamiLibrary } from '../AgamiLibrary/AgamiLibrary'

const DashboardAgami = () => {
  const { t } = useTranslation()
  const ondeFlag = useFeatureFlag(FEATURE_FLAGS.ONDE)
  usePageTitle(`${t(ondeFlag ? 'agamiLibrary.title' : 'dashboard.agamiLibraryTitle')} | Agami Dashboard`)
  const uploadSpotsAuth = useFeatureAuth(FEATURES.UPLOAD_SPOTS_UI)
  const { newAgamiPath } = useAgamiRoutes()
  return (
    <>
      <div className="w-full flex flex-col md:flex-row justify-between items-start md:items-start gap-4 py-4">
        <div className="flex flex-col lg:max-w-[60%]">
          <Typography variant="h1" className="text-2xl md:text-5xl" data-testid="agami-library-title">
            {t(ondeFlag ? 'agamiLibrary.title' : 'dashboard.agamiLibraryTitle')}
          </Typography>
          <Typography className="dark:text-gray-200">
            {t(ondeFlag ? 'agamiLibrary.description' : 'dashboard.agamiLibraryDescription')}
          </Typography>
        </div>
        <Link to={newAgamiPath()} data-testid="new-agami-link">
          <div className="flex items-center space-x-4">
            <IconButton size="sm" className="rounded-full">
              <AiOutlinePlus className="text-[20px]" />
            </IconButton>
            <Typography className="font-bold dark:text-gray-200">
              {t(ondeFlag ? 'agamiLibrary.newAgami' : 'dashboard.uploadAgami')}
            </Typography>
          </div>
        </Link>
      </div>
      {uploadSpotsAuth && (ondeFlag ? <AgamiLibrary /> : <AgamiCardGrid />)}
    </>
  )
}

export default DashboardAgami
